import { FlexContainer, LoadingPage } from '@act/storybook';
import type { SectionMetaDto } from '@act/shared/data-transfer-objects';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useEffect } from 'react';
import { reportsRequests } from 'redux/requests/reports.requests';
import { useApiCall } from 'redux/utils/apiHook.hook';
import ReportsPageHeader from '../components/ReportsPageHeader';
import ReportsSurface from '../components/ReportsSurface';

/**
 * Read-only catalog of the fixed 18-section report library.
 */
const SectionLibraryPage = () => {
  const [library, loading, loadLibrary] = useApiCall(
    reportsRequests.getSectionLibrary,
  );

  useEffect(() => {
    loadLibrary({ params: null });
  }, [loadLibrary]);

  if (loading) {
    return <LoadingPage />;
  }

  const sections = library?.sections ?? [];

  return (
    <FlexContainer
      direction="column"
      gap={2}
      width="100%"
      height="auto"
      overflowAllVisible={true}
    >
      <ReportsPageHeader
        title="Section library"
        subtitle="Fixed catalog of report sections. Reports toggle inclusion and order — new section types are not added here."
      />

      <ReportsSurface padding={0}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Order</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Narrative</TableCell>
              <TableCell>Callout</TableCell>
              <TableCell>Rationale</TableCell>
              <TableCell>Note</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sections.map((section: SectionMetaDto) => (
              <TableRow key={section.id}>
                <TableCell>{section.defaultOrder}</TableCell>
                <TableCell>{section.title}</TableCell>
                <TableCell>
                  {section.disabled ? 'Not ready' : 'Ready'}
                </TableCell>
                <TableCell>{section.supportsNarrative ? 'Yes' : 'No'}</TableCell>
                <TableCell>{section.supportsCallout ? 'Yes' : 'No'}</TableCell>
                <TableCell>{section.rationale}</TableCell>
                <TableCell>{section.note ?? '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ReportsSurface>
    </FlexContainer>
  );
};

export default SectionLibraryPage;
